const bazarListAf = {
  banner: {
    title: 'بازارونه',
    subtitle: 'له زرو څخه د دودیزو کلیوالي بازارونو څخه پیرود وکړئ',
    breadcrumbLabel: 'بازارونه',
    currentPlaceholder: 'خواړه ولټوئ...'
  },
  filter: {
    title: 'د فلټر اختیارونه',
    searchPlaceholder: 'بازارونه ولټوئ...',
    district: 'ولایت',
    upazilla: 'وړاندیز',
    size: 'د بازار اندازه',
    sortBy: 'د ترتیب له مخې',
    sortOptions: {
      name: 'نوم',
      storeCount: 'د پلورنځیو شمیر',
      rating: 'درجه بندي',
      visitors: 'مشهوریت'
    },
    clearShort: 'پاک کول',
    clearAll: 'ټول پاک کول',
    activeFilters: 'فعال فلټرونه:',
    labels: {
      search: 'لټون',
      district: 'ولایت',
      upazilla: 'وړاندیز',
      size: 'اندازه'
    }
  },
  results: {
    foundSuffix: 'بازارونه وموندل شول',
    none: 'هیڅ بازار و نه موندل شو',
    page: 'پاڼه'
  },
  empty: {
    title: 'هیڅ بازار ستاسو د لټون سره موافق نه دی',
    subtitle: 'مختلف فلټرونه هڅه کړئ یا ټول فلټرونه پاک کړئ',
    clear: 'ټول فلټرونه پاک کړئ'
  },
  card: {
    stores: 'پلورنځي',
    dailyVisitors: 'ورځني لیدونکي',
    specialties: 'تخصصونه:',
    details: 'تفصیلات',
    visit: 'لیدنه'
  },
  dialog: {
    title: 'مبارک شه!',
    selected: 'ستاسو بازار غوره شوی دی',
    instruction: 'ستاسو اوسنی بازار اوس غوره شوی دی. له لاندې هغه کتګوري غوره کړئ چې تاسو یې پیرود کول غواړئ:',
    categoryPrompt: 'تاسو څه پیرود کول غواړئ؟',
    bottomNotePrefix: 'دا محصولات به له هغه ځایه راشي',
    bottomNoteSuffix: '',
    close: 'وروسته وګورئ'
  }
};

export default bazarListAf;
